import i18n from '../i18n';

export const SUPPORTED_LOCALES = ['uk', 'en'];
export const LOCALE_STORAGE_KEY = 'app_locale';

export function normalizeLocale(value) {
    const normalized = String(value || '').toLowerCase().trim().replace('_', '-');
    if (SUPPORTED_LOCALES.includes(normalized)) {
        return normalized;
    }

    const baseLocale = normalized.split('-')[0];
    if (SUPPORTED_LOCALES.includes(baseLocale)) {
        return baseLocale;
    }

    return '';
}

export function getStoredLocale() {
    if (typeof window === 'undefined' || !window.localStorage) {
        return '';
    }

    try {
        return normalizeLocale(window.localStorage.getItem(LOCALE_STORAGE_KEY));
    } catch (e) {
        return '';
    }
}

export function setStoredLocale(locale) {
    const normalized = normalizeLocale(locale);
    if (!normalized || typeof window === 'undefined' || !window.localStorage) {
        return;
    }

    try {
        window.localStorage.setItem(LOCALE_STORAGE_KEY, normalized);
    } catch (e) {
        // Ignore storage access issues.
    }
}

export function getBrowserLocale() {
    if (typeof navigator === 'undefined') {
        return '';
    }

    const raw = navigator.language || navigator.userLanguage || '';
    const base = String(raw).split('-')[0];

    return normalizeLocale(base);
}

export function resolveGuestLocale() {
    return getStoredLocale() || getBrowserLocale() || 'uk';
}

export function applyLocale(locale) {
    const normalized = normalizeLocale(locale) || 'uk';
    setStoredLocale(normalized);

    if (i18n.language !== normalized) {
        i18n.changeLanguage(normalized);
    }

    return normalized;
}

export function applyUserLocale(user) {
    return applyLocale(user?.locale || 'uk');
}

export function getCurrentLocale() {
    return normalizeLocale(i18n.resolvedLanguage || i18n.language) || getStoredLocale() || 'uk';
}

export async function saveUserLocale(locale) {
    const normalized = normalizeLocale(locale);
    if (!normalized) {
        throw new Error('Unsupported locale');
    }

    const response = await fetch('/api/v1/profile/locale', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({locale: normalized}),
    });

    if (!response.ok) {
        throw new Error('Failed to save locale');
    }

    const payload = await response.json().catch(() => ({}));

    return normalizeLocale(payload?.locale) || normalized;
}
